(function() {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodGridDetail', sodGridDetail);

    function sodGridDetail() {
        return {
            restrict: 'E',
            scope: { config: '=' },
            templateUrl: 'common/components/sod-grid-detail',
            controller: sodGridDetailCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };

        function sodGridDetailCtrl($scope, lodash, SodGridFactory, GroupFilterFactory) {
            var vm = this;

            this.$onInit = function() {
                // functions
                vm.sodGridInstance = SodGridFactory(vm.config);
                vm.groupFilterFactory = GroupFilterFactory(lodash.get(vm, 'config.id', null));

                init();
            }


            function init() {
                vm.isLoading = true;
                handleCountShowJob();
                var groupFilterFactoryApplyFilter = $scope.$on(
                    [vm.groupFilterFactory.eventPrefix, lodash.get(vm, 'config.id', null)].join('.'),
                        function (e, eventData) {
                        handleCountShowJob();
                    }
                );

                var sodGridLoadingListener = $scope.$on(
                    [vm.sodGridInstance.eventPrefix, lodash.get(vm, 'config.id', null), vm.sodGridInstance.eventLoading].join('.'),
                    function (e, eventData) {
                        vm.isLoading = eventData;
                    }
                );

                $scope.$on('destroy', function() {
                    groupFilterFactoryApplyFilter();
                    sodGridLoadingListener();
                });
            }

            function handleCountShowJob() {
                vm.count = vm.groupFilterFactory.getCount();

                if (vm.count === 0) {
                    vm.sodGridInstance.selectJob(lodash.get(vm, 'config.id'), null);
                }
            }

        }
    }
})();